import { useEffect,useState } from 'react'
import { useNavigate,useParams } from 'react-router-dom'
import leaflet from 'leaflet'
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet'
import { Card, CardContent, CircularProgress, FormControl, Grid, TextField, Autocomplete } from '@mui/material'
import { post } from '../../../utils/axios'
import { toast } from 'react-toastify'
import Button from '../../../components/Button'

import icon from 'leaflet/dist/images/marker-icon.png'
import iconShadow from 'leaflet/dist/images/marker-shadow.png'

import 'leaflet/dist/leaflet.css'

const defaultIcon = leaflet.icon({
    iconUrl: icon,
    shadowUrl: iconShadow
})

leaflet.Marker.prototype.options.icon = defaultIcon

const GetCoordinates = ({ setMarkerPos, setLang, setLat, setMarkerPosCreate }) => {
    const map = useMap();
    useEffect(() => {
        if (!map) return;
        const info = leaflet.DomUtil.create('div', 'legend');
        const positon = leaflet.Control.extend({
            options: {
                position: 'bottomleft'
            },
            onAdd: function () {
                info.textContent = '';
                return info;
            }
        })
        map.on('click', (e) => {
            info.textContent = e.latlng;
            setMarkerPos(e.latlng)
            setMarkerPosCreate(e.latlng)
            setLat(e.latlng.lat)
            setLang(e.latlng.lng)
        })
        map.addControl(new positon());
    }, [map])
    return null
}

const MapWrapper = ({ lat, setLat, lang, setLang, markerPosCreate, setMarkerPosCreate,center }) => {
    const [markerPos, setMarkerPos] = useState({
        lat: lat,
        lng: lang,
    })
    return (
        <MapContainer center={center} style={{width: '100%',height: '220px',}} zoom={13} scrollWheelZoom={false}>
            <TileLayer attribution='<a href="https://www.sabinarya.com">سابین تجارت آریا</a>' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <Marker position={[markerPos.lat, markerPos.lng]}>
                <Popup>{markerPos.lat}  {markerPos.lng} </Popup>
            </Marker>
            <GetCoordinates markerPos={markerPos} setMarkerPos={setMarkerPos} markerPosCreate={markerPosCreate} setMarkerPosCreate={setMarkerPosCreate} lat={lat} setLat={setLat} lang={lang} setLang={setLang} />
        </MapContainer>
    )
}

const EditAddress = () => {

    const navigate = useNavigate()
    const {id} = useParams()

    const [isLoading,setIsLoading] = useState(true)
    const [address,setAddress] = useState({title: '',provinceId: 0,cityId: 0,postalCode: '',address: '',phone: '',buildingNo: '',floor: '',unit: ''})
    const [provinces,setProvinces] = useState([])
    const [cities,setCities] = useState([])
    const [markerPosCreate,setMarkerPosCreate] = useState({})
    const [lat,setLat] = useState(30.5589)
    const [lang,setLang] = useState(49.1981)
    const [center,setCenter] = useState([30.5589,49.1981])

    useEffect(() => {
        post('General/GetProvince').then(({data}) => {
            if(data.isSuccess){
                const items = []
                data.data.map(item => items.push({
                    label: item.title,
                    id: item.id
                }))
                setProvinces(items)
            }
        })
        const postedData = {
            id
        }
        post('Address/GetAddressById',postedData).then(({data}) => {
            if(data.isSuccess){
                setAddress({
                    ...data.data,
                    buildingNo: data.data.buildingNo || '',
                    floor: data.data.floor || '',
                    unit: data.data.unit || ''
                })
                setLat(data.data.latitude || '')
                setLang(data.data.longitude || '')
                if(data.data.latitude && data.data.longitude)
                    setCenter([data.data.latitude,data.data.longitude])
            }
        }).finally(() => setIsLoading(false))
    },[])

    useEffect(() => {
        if(!address.provinceId)
            return
        const postedData = {
            provinceId: address.provinceId
        }
        post('General/GetCity',postedData).then(({data}) => {
            if(data.isSuccess){
                const items = []
                data.data.map(item => items.push({
                    label: item.title,
                    id: item.id
                }))
                setCities(items)
            }
        })
    },[address.provinceId])

    useEffect(() => {
        if(address.phone && address.phone.length){
            if(address.phone.includes('۰'))
                setAddress({...address,phone: address.phone.replace(/۰/g,'0')})
            if(address.phone.includes('۱'))
                setAddress({...address,phone: address.phone.replace(/۱/g,'1')})
            if(address.phone.includes('۲'))
                setAddress({...address,phone: address.phone.replace(/۲/g,'2')})
            if(address.phone.includes('۳'))
                setAddress({...address,phone: address.phone.replace(/۳/g,'3')})
            if(address.phone.includes('۴'))
                setAddress({...address,phone: address.phone.replace(/۴/g,'4')})
            if(address.phone.includes('۵'))
                setAddress({...address,phone: address.phone.replace(/۵/g,'5')})
            if(address.phone.includes('۶'))
                setAddress({...address,phone: address.phone.replace(/۶/g,'6')})
            if(address.phone.includes('۷'))
                setAddress({...address,phone: address.phone.replace(/۷/g,'7')})
            if(address.phone.includes('۸'))
                setAddress({...address,phone: address.phone.replace(/۸/g,'8')})
            if(address.phone.includes('۹'))
                setAddress({...address,phone: address.phone.replace(/۹/g,'9')})
        }
    },[address.phone])

    const updateAddress = () => {
        setIsLoading(true)
        const postedData = {
            id,
            ...address,
            latitude: lat.toString(),
            longitude: lang.toString(),
        }
        post('Address/UpdateAddress',postedData).then(({data}) => {
            if(data.isSuccess){
                toast.success('آدرس با موفقیت به روزرسانی شد')
                navigate(-1)
            }else
                toast.error(data.message)
        }).finally(() => setIsLoading(false))
    }

    return (
        <Grid item px={0.3} sx={{position: 'relative'}}>
            <h3 className="others-page-title">به روزرسانی آدرس</h3>
            <div className="safe-area">
                <Card sx={{width: '100%',mb: 2}}>
                    <CardContent sx={{py: 3,pb: 4}}>
                        <FormControl fullWidth sx={{mb: 3}}>
                            <Autocomplete
                                options={provinces}
                                autoHighlight
                                value={address.provinceId ? provinces.find(province => province.id == address.provinceId) : {label: ''}}
                                onChange={(e,value) => setAddress({...address,provinceId: value?.id || 0})}
                                getOptionLabel={(option) => option.label}
                                noOptionsText="یافت نشد"
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="استان"
                                        inputProps={{
                                            ...params.inputProps,
                                            autoComplete: 'new-password'
                                        }}
                                    />
                                )}
                            />
                        </FormControl>
                        
                        <FormControl fullWidth>
                            <Autocomplete
                                options={cities}
                                autoHighlight
                                value={address.cityId ? cities.find(city => city.id == address.cityId) : {label: ''}}
                                onChange={(e,value) => setAddress({...address,cityId: value?.id || 0})}
                                getOptionLabel={(option) => option.label}
                                noOptionsText="یافت نشد"
                                disabled={!address.provinceId}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="شهر"
                                        inputProps={{
                                            ...params.inputProps,
                                            autoComplete: 'new-password'
                                        }}
                                    />
                                )}
                            />
                        </FormControl>
                        <TextField label="عنوان" variant="standard" fullWidth sx={{mt: 2.5,mb: 2.5}} onChange={e => setAddress({...address,title: e.target.value})} value={address.title} />
                        <TextField label="آدرس" variant="standard" fullWidth sx={{mb: 2.5}} onChange={e => setAddress({...address,address: e.target.value})} value={address.address} />
                        <TextField label="پلاک" type="tel" inputProps={{maxLength: 4}} variant="standard" fullWidth sx={{mb: 2.5}} onChange={e => setAddress({...address,buildingNo: e.target.value})} value={address.buildingNo} />
                        <TextField label="طبقه" type="tel" inputProps={{maxLength: 4}} variant="standard" fullWidth sx={{mb: 2.5}} onChange={e => setAddress({...address,floor: e.target.value})} value={address.floor} />
                        <TextField label="واحد" type="tel" inputProps={{maxLength: 4}} variant="standard" fullWidth sx={{mb: 2.5}} onChange={e => setAddress({...address,unit: e.target.value})} value={address.unit} />
                        <TextField label="کد پستی" type="tel" inputProps={{maxLength: 10}} variant="standard" fullWidth sx={{mb: 2.5}} onChange={e => setAddress({...address,postalCode: e.target.value})} value={address.postalCode} />
                        <TextField label="شماره همراه" type="tel" inputProps={{maxLength: 11}} variant="standard" fullWidth sx={{mb: 2.5}} onChange={e => setAddress({...address,phone: e.target.value})} value={address.phone} />
                        {!isLoading ? <MapWrapper lat={lat} setLat={setLat} lang={lang} setLang={setLang} markerPosCreate={markerPosCreate} setMarkerPosCreate={setMarkerPosCreate} center={center} /> : ''}
                        <Button type="submit" isLoading={isLoading} fullWidth={true} sx={{mt: 2,py: 1.5}} className="custom-btn-primary" variant="contained" disabled={!address.provinceId || !address.cityId || !address.cityId || !address.address || !address.phone.startsWith('09') || address.phone.length != 11} onClick={updateAddress}>{isLoading ? <CircularProgress size={24} /> : 'ذخیره اطلاعات'}</Button>
                    </CardContent>
                </Card>
            </div>
        </Grid>
    )
}

export default EditAddress